module.exports = __webpack_public_path__ + "static/media/iconFive.7cd79e2e.svg";